import { CirclePause } from "lucide-react";
import type { AgentWithContext } from "@/lib/types";
import { cn } from "@/lib/utils";

const TINT = "var(--kind-active)";

/**
 * "Paused for deploy": a worker draining for a deploy has paused (or is pausing)
 * this agent's run at a clean point, and the new worker resumes it. Nothing otherwise.
 * `compact` is the list row's shorter form.
 */
export function DeployPausePill({ agent, compact = false, className }: { agent: AgentWithContext; compact?: boolean; className?: string }) {
  if (!agent.pausedForDeploy) return null;
  return (
    <span
      title="The board is being deployed. This agent's run pauses at the end of the step it is on, and carries on where it was once the new worker is up."
      className={cn("inline-flex shrink-0 items-center gap-1 rounded-full px-1.5 py-px text-[10.5px] font-medium leading-4", className)}
      style={{ color: TINT, backgroundColor: `color-mix(in oklab, ${TINT} 16%, transparent)` }}
    >
      <CirclePause className="size-3" aria-hidden />
      {compact ? "paused" : "Paused for deploy"}
    </span>
  );
}
